const blogs = [
  {
    id: 1,
    date: "2024-12-20",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Dicas para Maximizar Seus Ganhos no 333bet4",
    descr:
      "Descubra estratégias exclusivas para aproveitar os melhores jogos e bônus.",
    fullText:
      "Aproveitar ao máximo sua experiência no 333bet4 envolve planejamento e estratégias claras.\n\n1. Gerencie seu orçamento: Defina limites claros para seus gastos.\n\n2. Explore os bônus disponíveis: Aproveite as promoções como 'Pegue um presente do Papai Noel'.\n\n3. Escolha seus jogos favoritos: Concentre-se nos que oferecem maiores chances de ganhos.\n\n4. Leia as regras: Compreender os jogos é essencial para o sucesso.\n\n5. Jogue com responsabilidade: Respeite seus limites e evite decisões impulsivas.\n\n6. Pratique em modos demo: Isso ajuda a se familiarizar sem riscos.\n\n7. Participe de torneios: Eles oferecem prêmios maiores e competições emocionantes.\n\nCom essas dicas, você estará preparado para aproveitar ao máximo o 333bet4 e suas vantagens únicas.",
  },
  {
    id: 2,
    date: "2024-12-18",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Os Melhores Jogos de Cassino no 333bet4",
    descr: "Uma análise completa dos jogos mais populares e empolgantes.",
    fullText:
      "O 333bet4 oferece uma seleção incrível de jogos que prometem diversão e prêmios. Confira:\n\n1. Slots temáticos: Descubra jogos com temas únicos e gráficos incríveis.\n\n2. Roleta clássica: Um dos jogos mais amados, com emoção em cada giro.\n\n3. Blackjack estratégico: Teste suas habilidades em um jogo de cartas icônico.\n\n4. Poker virtual: Combine sorte e estratégia para vencer.\n\n5. Aviator: Um jogo dinâmico que combina simplicidade e potencial de grandes prêmios.\n\n6. Fortune Tiger: Rodadas vibrantes com o tema de um tigre majestoso.\n\nExplore esses jogos e aproveite as promoções como 'Inscreva-se e receba um presente'. O 333bet4 tem algo especial para todos os jogadores.",
  },
  {
    id: 3,
    date: "2024-12-15",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Como Participar dos Torneios do 333bet4",
    descr: "Aprenda a competir e ganhar nos melhores torneios de cassino.",
    fullText:
      "Os torneios no 333bet4 são uma excelente oportunidade para ganhar grandes prêmios. Veja como participar:\n\n1. Faça login: Certifique-se de que sua conta está ativa.\n\n2. Confira o calendário: Acesse a aba de torneios para ver as próximas competições.\n\n3. Inscreva-se: Muitos torneios exigem registro prévio.\n\n4. Conheça as regras: Cada torneio tem requisitos específicos que devem ser seguidos.\n\n5. Participe com estratégia: Planeje suas apostas e gerencie seu tempo.\n\n6. Aproveite os bônus: Durante os torneios, promoções exclusivas estão disponíveis.\n\n7. Mantenha a calma: Torneios podem ser intensos, mas a diversão é garantida.\n\nCom essas dicas, você estará pronto para se destacar nos torneios do 333bet4. Não esqueça de 'Fazer um depósito para participar do sorteio de Ano Novo'.",
  },
  {
    id: 4,
    date: "2024-12-12",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Segurança e Confiabilidade no 333bet4",
    descr:
      "Descubra como o 333bet4 protege seus dados e garante uma experiência segura.",
    fullText:
      "A segurança é uma prioridade no 333bet4. Conheça as medidas adotadas:\n\n1. Criptografia avançada: Todos os dados são protegidos com tecnologia de ponta.\n\n2. Certificação SSL: Garantia de que suas informações estão seguras.\n\n3. Verificação de identidade: Proteção contra acessos não autorizados.\n\n4. Suporte 24/7: Atendimento disponível para resolver quaisquer problemas.\n\n5. Política de privacidade: Seus dados são usados apenas para melhorar sua experiência.\n\n6. Jogabilidade justa: Os jogos seguem padrões rigorosos de transparência.\n\n7. Alertas de segurança: Mantenha seu cadastro atualizado para receber notificações importantes.\n\nCom essas práticas, o 333bet4 oferece um ambiente confiável para você se divertir e ganhar prêmios.",
  },
  {
    id: 5,
    date: "2024-12-10",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Benefícios Exclusivos do 333bet4",
    descr:
      "Saiba tudo sobre as vantagens e promoções especiais disponíveis para você.",
    fullText:
      "O 333bet4 oferece uma variedade de benefícios exclusivos para seus usuários. Veja alguns deles:\n\n1. Bônus de boas-vindas: Receba uma recompensa ao se cadastrar.\n\n2. Promoções sazonais: Como 'Pegue um presente do Papai Noel', para aproveitar a temporada de festas.\n\n3. Programa VIP: Benefícios exclusivos para jogadores frequentes.\n\n4. Suporte dedicado: Equipe pronta para ajudar a qualquer momento.\n\n5. Acessibilidade: Jogue onde quiser com o 333bet app.\n\n6. Jogos inovadores: Experimente novos lançamentos regularmente.\n\n7. Depósitos seguros: Garantia de que suas transações são protegidas.\n\nCom essas vantagens, o 333bet4 se destaca como uma das melhores opções para entretenimento online. Explore e aproveite ao máximo!",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo")) return;
      if (img.closest(".santaBonus")) return;

      img.onclick = () =>
        window.location.assign("https://opimisil.com/W55gYd1g");
    });
  }
});
